// ui
import { Box, Alert } from "@mui/material";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

interface OutSideStartStopModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  startStopDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setStartStopDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  startStopData: () => void;
}

export function OutSideStartStopModal(props: OutSideStartStopModalProps) {
  const {
    onModal,
    swCloseModal,
    startStopDataInf,
    setStartStopDataInf,
    startStopData,
  } = props;

  const footer =
    startStopDataInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          data-testid="outside-start-stop-close"
          onClick={swCloseModal}
        >
          閉じる
        </PoButton>
        <PoButton
          variant="primary"
          data-testid="outside-start-stop-submit"
          onClick={startStopData}
        >
          {/* ★保全ガード③: start⇔stop文言/アイコン切替は不可触 */}
          {startStopDataInf.key.startStop === "start" ? "公開" : "非公開"}
          {startStopDataInf.key.startStop === "start" ? (
            <PlayCircleOutlineIcon fontSize="small" />
          ) : (
            <DoDisturbAltIcon fontSize="small" />
          )}
        </PoButton>
      </>
    ) : startStopDataInf.status === "success" ? (
      <PoButton
        variant="secondary"
        data-testid="outside-start-stop-success-close"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : startStopDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        data-testid="outside-start-stop-failed-back"
        onClick={() =>
          setStartStopDataInf({
            ...startStopDataInf,
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title="公開・非公開"
      onClose={swCloseModal}
      testidPrefix="outside-start-stop"
      footer={footer}
    >
      {startStopDataInf.status === "open" ? (
        <>
          {/* ★保全ガード③: start⇔stop文言/アイコン切替は不可触 */}
          <Alert
            severity="error"
            sx={{
              bgcolor: "var(--sem-error-bg, #f6d5d1)",
              color: "var(--sem-error, #a53229)",
              fontSize: 12,
              borderRadius: "var(--radius-md, 10px)",
              p: "var(--sp-3, 12px) var(--sp-4, 16px)",
              "& .MuiAlert-icon": { color: "var(--sem-error, #a53229)" },
            }}
          >
            {startStopDataInf.key.startStop === "start" ? (
              <>
                サイトが公開されます。
                <br />
                ※再開後、外部エントリー可能となります。
              </>
            ) : startStopDataInf.key.startStop === "stop" ? (
              <>
                サイトが非公開されます。
                <br />
                ※停止後、外部エントリー不可能となります。
                <br />
                ※すでに登録済のエントリーに影響はありません。
              </>
            ) : null}
          </Alert>
        </>
      ) : startStopDataInf.status === "success" ? (
        <Box className="result-state -success" data-testid="result-state-success">
          <span className="rs-title">成功しました。</span>
        </Box>
      ) : startStopDataInf.status === "failed" ? (
        <Box className="result-state -failed" data-testid="result-state-failed">
          <span className="rs-title">{startStopDataInf.message}</span>
        </Box>
      ) : null}
    </PoModalShell>
  );
}
